export default __webpack_public_path__ + "static/media/double-bell.fcd797d2.mp3";